var map = {
	"./card-back.svg": 7400,
	"./card-front.svg": 7586,
	"./empty.svg": 3170,
	"./female.svg": 7962,
	"./kuang.svg": 3482,
	"./login-bg.svg": 8563,
	"./logo.svg": 7503,
	"./male.svg": 5653,
	"./noAccount.svg": 1136,
	"./riskLevel.svg": 3547,
	"./riskLevel0.svg": 3985,
	"./riskLevel1.svg": 9600,
	"./riskLevel2.svg": 611,
	"./riskLevel3.svg": 6882,
	"./riskLevel4.svg": 5405,
	"./riskLevel5.svg": 8044,
	"./simple1.svg": 3505,
	"./simple2.svg": 4018,
	"./simple3.svg": 5011,
	"./simple4.svg": 4828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9832;